<template>
  <el-tag v-if="state && stateLabel" size="medium" :type="cssClass"
    >{{ stateLabel }}
  </el-tag>
</template>

<script>
import constants from "../../../constants";
import hanhChinhUtils from "../../../services/hanhChinhUtils";

export default {
  name: "hc-maybay-state",
  props: ["state"],

  computed: {
    stateLabel() {
      return hanhChinhUtils.getMayBayStateLabel(this.state);
    },

    cssClass() {
      switch (this.state) {
        case constants.HC_STATE.STATE_CODE.MAY_BAY.HUY:
          return "danger";
        case constants.HC_STATE.STATE_CODE.MAY_BAY.DA_PHE_DUYET:
          return "success";
        case constants.HC_STATE.STATE_CODE.MAY_BAY.TU_CHOI:
          return "danger";
        case constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET:
        default:
          return "";
      }
    }
  },

  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-state.vue